//shared helpers for the leave services.

export const extractRows = (body) => {
    if(Array.isArray(body)) return body;
    if(Array.isArray(body?.resultSet)) return body.resultSet;
    if(Array.isArray(body?.ResultSet)) return body.ResultSet;
    if(Array.isArray(body?.data)) return body.data;
    if(Array.isArray(body?.data?.resultSet)) return body.data.resultSet;
    if(Array.isArray(body?.data?.ResultSet)) return body.data.ResultSet;
    return[];
};

export const toDateKey = (date) => {
    if(!date) return "";
    const d = new Date(date);
    if(isNaN(d.getTime())) return String(date);
    const p = (n) => String(n).padStart(2,"0");
    return `${d.getFullYear()}-${p(d.getMonth()+1)}-${p(d.getDate())}`;
};

export const assertOk = (body) => {
  const code = body?.statusCode ?? body?.StatusCode;
  if (code !== undefined && code !== 200) {
    const msg = String(body?.Result || body?.Message || `Server error (status ${code})`);
    throw new Error(msg.split("\n")[0].trim());
  }
  return body;
};

export const toEmployeeOptions = (raw) =>
  extractRows(raw)
    .map((e) => {
      const serviceNo = String(e.serviceNo ?? e.ServiceNo ?? "").trim();
      return {
        serviceNo,
        name: e.reportName || e.ReportName || e.name || serviceNo,
        department: e.department || e.DepartmentCode || e.Designation || "",
      };
    })
    .filter((e) => e.serviceNo);

    export const friendlyError = (
  raw,
  fallback = "Something went wrong. Please try again.",
  duplicateMessage = "This record already exists."
) => {
  const msg = String(raw || "").trim();
  if (!msg) return fallback;

  const technical = (text) => {
    console.error("[Server error]", msg);
    return text;
  };

  if (/violation of (unique|primary) key|duplicate key|unique constraint|\bUK_|\bPK_/i.test(msg)) {
    return technical(duplicateMessage);
  }
  if (/cannot insert the value null|does not allow nulls/i.test(msg)) {
    return technical("Some required information is missing, so this could not be saved. Please check the form or contact support.");
  }
  if (/foreign key|\bFK_/i.test(msg)) {
    return technical("This action refers to a record that does not exist or is still in use.");
  }
  if (/\bdbo\.|insert fails|statement has been terminated|sqlexception|ora-\d+/i.test(msg)) {
    return technical(fallback);
  }
  return msg;
};